import request from '@utils/request'

/**
 * 查询防伪
 * @returns {*}
 */
export function getCode (code) {
  return request.post('query', { fwm: code }, { login: false })
}
